var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stats-panel"},[_c('div',{staticClass:"stats-panel__hd"},[_vm._t("header",function(){return [_vm._v(_vm._s(_vm.title))]})],2),_c('div',{staticClass:"stats-panel__bd"},[_c('vh-row',{staticClass:"stats-panel__row",attrs:{"type":"flex"}},[_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }